export const calculateDateInterval = (days: number, to = new Date()) => {
  const today = to;
  const pastDate = new Date(+today - days * 24 * 60 * 60 * 1000);
  return [pastDate, today];
};

export const convertFormattedDateToRawValue = (formattedString: string, separator: string) => {
  const dateParts = formattedString.split(separator);
  if (dateParts.length !== 3)
    return null;
  const [day, month, year] = dateParts;
  return new Date(+year, +month - 1, +day);
};
